import React from 'react'

import { Box, Hidden } from '@material-ui/core'

import { DescriptionBox, Stepper } from './components'

import useClientPortalTheme from 'hooks/useClientPortalTheme'

import SupplierJourneyProvider from 'providers/SupplierJourneyProvider'

import logoDponetWhite from 'images/dponet-logo-white.svg'
import useStyles from './styles'
import { ScreenLoading } from 'layouts/Main/components'

const SuppliersJourneyLayout = ({ children }) => {
  const classes = useStyles()
  const { clientPortalTheme, isLoading } = useClientPortalTheme()

  return (
    <SupplierJourneyProvider>
      <ScreenLoading loaded={!isLoading}>
        <Box className={classes.root}>
          <Box className={classes.leftBox}>
            <Box className={classes.image}>
              <img
                src={clientPortalTheme?.logo || logoDponetWhite}
                alt="Logo DPOnet Branca"
                className={classes.image}
              />
            </Box>
            <Hidden mdDown>
              <DescriptionBox />
            </Hidden>
            <Stepper />
          </Box>
          <Box className={classes.wrapper}>
            <Box
              width="100%"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Box width="100%" height="100%">
                {children}
              </Box>
            </Box>
          </Box>
        </Box>
      </ScreenLoading>
    </SupplierJourneyProvider>
  )
}

export default SuppliersJourneyLayout
